import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=d6f004da&"
import script from "./statistic.vue?vue&type=script&lang=js&"
export * from "./statistic.vue?vue&type=script&lang=js&"
import style0 from "./statistic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports